/**
 * SingleAlert.jsx
 * Created by michaelbray on 8/6/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../../sharedComponents/icons/Icons';
import DisplayHtmlContent from '../../sharedComponents/DisplayHtmlContent';

const propTypes = {
    alertClassName: PropTypes.string,
    alertIcon: PropTypes.node,
    alertTitle: PropTypes.string,
    alert: PropTypes.shape({
        body: PropTypes.node
    }),
    closeAlert: PropTypes.func
};

export default class SingleAlert extends React.PureComponent {
    render() {
        return (
            <div className={this.props.alertClassName} role="alert" aria-labelledby="alertHeading">
                <div className="rec-msg">
                    <div className="rec-msg-text">
                        <div className="rec-msg-text-type" id="alertHeading">
                            <div className="rec-alerts-notification-icon">
                                {this.props.alertIcon}
                            </div>
                            <strong>
                                {this.props.alertTitle}
                            </strong>
                        </div>
                        <div className="rec-msg-text-content">
                            <ul>
                                <li>
                                    <DisplayHtmlContent html={this.props.alert.body} />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button
                        className="rec-notification-close"
                        aria-label="Close notification"
                        onClick={this.props.closeAlert}>
                        <Icons.IconClose className="rec-icon-close" />
                    </button>
                </div>
            </div>
        );
    }
}

SingleAlert.propTypes = propTypes;
